/**
 * Data layer for `igaming-crypto-payment-tracking-usdt-btc-eth-on-pl`. Thin typed fetch wrappers over /api/v1/igaming-crypto-payment-tracking-usdt-btc-eth-on-pl.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlResponse {
	count: number;
	items: IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow[];
}

export interface CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-crypto-payment-tracking-usdt-btc-eth-on-pl";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingCryptoPaymentTrackingUsdtBtcEthOnPlResponse>(res);
}

export async function create(body: CreateIgamingCryptoPaymentTrackingUsdtBtcEthOnPlBody): Promise<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingCryptoPaymentTrackingUsdtBtcEthOnPlRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys = {
	all: ["igaming-crypto-payment-tracking-usdt-btc-eth-on-pl"] as const,
	list: () => [...igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys.all] as const,
	detail: (id: string) => [...igamingCryptoPaymentTrackingUsdtBtcEthOnPlQueryKeys.all, id] as const,
};
